import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMemberClubCardSpool } from "src/models/Customers/MemberClub.models";

interface MemberClubCardSpoolState {
  memberClubCardSpools: IMemberClubCardSpool[];
  memberClubCardSpoolToEdit: IMemberClubCardSpool | null;
}

const initialState: MemberClubCardSpoolState = {
  memberClubCardSpools: [],
  memberClubCardSpoolToEdit: null,
};

const memberClubCardSpoolSlice = createSlice({
  name: "MemberClubCardSpool",
  initialState,
  reducers: {
    setMemberClubCardSpoolList: (
      state,
      action: PayloadAction<IMemberClubCardSpool[]>
    ) => {
      state.memberClubCardSpools = action.payload;
    },
    concatListMemberClubCardSpool: (
      state: MemberClubCardSpoolState,
      action: PayloadAction<IMemberClubCardSpool[]>
    ) => {
      state.memberClubCardSpools = [
        ...state.memberClubCardSpools.concat(action.payload),
      ];
    },
    setMemberClubCardSpoolToEdit: (
      state,
      action: PayloadAction<IMemberClubCardSpool | null>
    ) => {
      state.memberClubCardSpoolToEdit = action.payload;
    },
    addMemberClubCardSpool: (state, action: PayloadAction<IMemberClubCardSpool>) => {
      state.memberClubCardSpools.push(action.payload);
    },
    updateMemberClubCardSpool: (
      state,
      action: PayloadAction<IMemberClubCardSpool>
    ) => {
      let itemIndex = state.memberClubCardSpools.findIndex(
        item => item.memberClubCardSpoolId === action.payload.memberClubCardSpoolId
      );
      if (itemIndex !== -1) state.memberClubCardSpools[itemIndex] = action.payload;
    },
    deleteMemberClubCardSpool: (state, action: PayloadAction<number>) => {
      const newArray = state.memberClubCardSpools.filter(
        item => item.memberClubCardSpoolId !== action.payload
      );
      state.memberClubCardSpools = newArray;
    },
  },
});

export const {
  setMemberClubCardSpoolList,
  concatListMemberClubCardSpool,
  setMemberClubCardSpoolToEdit,
  addMemberClubCardSpool,
  updateMemberClubCardSpool,
  deleteMemberClubCardSpool,
} = memberClubCardSpoolSlice.actions;

export default memberClubCardSpoolSlice.reducer;
